export const data = [
  {
    pair: "DELFC4 - ggnfc6",
    value: 2671563,
    otif: 94.4141689373297,
    quantity: 1482
  },
  {
    pair: "DELFC4 - ggnfc7",
    value: 2642368,
    otif: 94.5054945054945,
    quantity: 1477
  },
  {
    pair: "DELFC4 - ggnfc8",
    value: 1694840,
    otif: 94.5191313340227,
    quantity: 981
  },
  {
    pair: "DELFC4 - ggnfc5",
    value: 6453317,
    otif: 94.8568088836937,
    quantity: 3463
  }
];
export const displayedColumns5 = ["pair", "otif", "value", "quantity"];
